export default {
	algoliaAPIKey: process.env.ALGOLIA_API_KEY,
	algoliaAppID: process.env.ALGOLIA_APP_ID,
	algoliaIndexName: process.env.ALGOLIA_INDEX_NAME || 'products',
	googleAPIKey: process.env.GOOGLE_API_KEY,
};
